import {Plan} from "../../../types";

type ValidationIssue = { kind: "opposingOpeningDirections"; ids: string[] }

type ValidationResult = {
    ok: boolean;
    issues: ValidationIssue[];
}

export const validateManholeOpeningDirections = (plan: Plan): ValidationResult => {
    const manholes = plan.lid?.manholes ?? [];
    if (manholes.length <= 1) return {ok: true, issues: []};

    function getOpposingDirectionIds(direction1: string, direction2: string): string[] {
        if (
            manholes.some(m => m.openingDirection === direction1) &&
            manholes.some(m => m.openingDirection === direction2)
        ) {
            return manholes.filter(m => m.openingDirection === direction1 || m.openingDirection == direction2)
                .map(m => m.id)
        }
        return []
    }

    const leftRightOpposingIds = getOpposingDirectionIds('left', 'right');
    const upDownOpposingIds = getOpposingDirectionIds('up', 'down');

    if (leftRightOpposingIds.length > 0 || upDownOpposingIds.length > 0) {
        return {
            ok: false,
            issues: [
                {kind: "opposingOpeningDirections", ids: [...leftRightOpposingIds, ...upDownOpposingIds]},
            ]
        }
    }
    return {ok: true, issues: []};
}
